import React, { useContext, useEffect, useState } from "react";
import Banner from "../Banner";
import "./Header.css";
import shareButton from "../../assests/popup/shareButton.svg";
import user from "../../assests/user.svg";
import moment from "moment";
import { useUserAuth } from "../../context/UserAuthContext";
import { useLocation, useNavigate, useParams } from "react-router";
import SharePopup from "../SharePopup/SharePopup";
import back from "../../assests/popup/backButton.svg";
import backButtonArrow from "../../assests/backButtonArrow.svg";
import bellicon from "../../assests/bellicon.svg";
import axios from "axios";
import Context from "../../context/Context";
import { createSearchParams } from "react-router-dom";

function Header({ details, type, coverImage, isFixed, headingStyle, heading }) {
  const [countdown, setCountdown] = useState({});
  const [share, setShare] = useState(false);
  const { currentUser, setPreviousLocation, previousLocation, searchParams } =
    useUserAuth();
  // const targetDate = details?.endDate;
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const now = moment();
  //     const remainingTime = moment(targetDate).diff(now);

  //     const days = Math.floor(moment.duration(remainingTime).asDays());

  //     setCountdown({ days });
  //   }, 1000);
  //   return () => clearInterval(interval);
  // }, [targetDate]);
  // const organizerName = window.location.pathname.split("/")[1];
  // const campaignName = window.location.pathname.split("/")[2];
  const url = window.location.href;
  const { organizerName } = useParams();
  const campaignUniqueText = useParams().campaignUniqueText?.replace(
    /\.html$/,
    ""
  );
  const contestId = useParams().contestId?.replace(/\.html$/, "");
  const { verifyUser, userIdToken, setUploadSucccess, preview } =
    useContext(Context);
  const token = userIdToken || currentUser?.accessToken;
  const [newNotificationFound, setNewNotificationsFound] = useState(false);
  const campaignUniqueTextFromLocal =
    localStorage.getItem("campaignUniqueText");
  useEffect(() => {
    verifyUser();
    // if (currentUser) {
    //   newNotificationCheck();
    // }
  }, []);
  if (type == "signup") {
    var coverStyle = {
      background:
        "linear-gradient(180deg, #FCFF4B -11.56%, #E788FF 39.16%, #FF8989 87.54%)",
    };
  } else if (type == "participate") {
    var coverStyle = {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${coverImage}) center center / cover`,
    };
  } else {
    var coverStyle = {
      background: ` url(${coverImage}) center center / cover`,
    };
  }
  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate({
        pathname: `/profile`,
        search: "?preview=true",
      });
    } else {
      navigate({
        pathname: `/profile`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  const handleNotificationNavigate = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueText}/notification`,
        search: "?preview=true",
      });
    } else {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueText}/notification`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      });
    }
  };
  function ShareHandle() {
    setShare(share ? false : true);
  }
  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/signup`,
          search: "?preview=true",
        },
        {
          state: { previousLocation: location?.pathname },
        }
      );
    } else {
      navigate(`/signup`, {
        state: { previousLocation: location?.pathname },
      });
    }
  };
  const handleNavigate = () => {
    if (preview) {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueText}`,
        search: "?preview=true",
      });
    } else {
      navigate(`/${organizerName}/${campaignUniqueText}`);
    }

    // setFilterState(
    //   _.isEmpty(details?.filterChips) ? "ALL" : contestDetails?.contestType
    // );
  };
  const handleNavigateToPrevLocation = () => {
    if (previousLocation) {
      window.open(previousLocation, "_self");
    } else {
      if (preview) {
        navigate({
          pathname: `/${organizerName}/${campaignUniqueTextFromLocal}`,
          search: "?preview=true",
        });
      } else {
        navigate({
          pathname: `/${organizerName}/${campaignUniqueTextFromLocal}`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    }
  };
  const handleNavigateToContest = () => {
    setUploadSucccess(false);
    if (preview) {
      navigate({
        pathname: `/${organizerName}/${campaignUniqueText}/${contestId}`,
        search: "?preview=true",
      });
    } else {
      navigate(`/${organizerName}/${campaignUniqueText}/${contestId}`);
    }
  };
  const newNotificationCheck = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_NOTIFICATION_STATUS_CHECKER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then((response) => {
      setNewNotificationsFound(response?.data?.data?.newNotificationFound);
    });
  };

  return (
    <>
      <div
        className="h-[465px] relative min-h-[167px] max-h-[465px] w-[100%] bg-white cover-top fixedPos"
        style={coverStyle}
      >
        {headingStyle && (
          <>
            <style>@import url({headingStyle?.family});</style>
            <pre
              className=" header-dynamic-text px-[25px] py-[10px] w-[80%] "
              style={headingStyle?.style}
            >
              {heading}
            </pre>
          </>
        )}
        <div className="cover-bottom-shade absolute bottom-[0] z-0"></div>
      </div>
      {share && <SharePopup showShare={ShareHandle} type="contest" url={url} />}
    </>
  );
}

export default Header;
